import React from "react";

import { connect } from "react-redux";


import './Header.css';



import HeaderProfile from './HeaderProfile';
import MonthlyTransaction from "./MonthlyTransaction";
import SearchSenderDetails from './SearchSenderDetails';


class Header extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }


	

    componentDidMount(){

	var amount=3000;
	var slab=5000;

	var slabCount=parseInt(amount/slab);
	
	var slabReminder=amount%slab;
	var slabReminderCount=0;

	var amountArray=[];

	for( var i = 0; i < slabCount; i++){
		amountArray.push(5000); 
	}

	if(slabReminder>0){
		slabReminderCount=1;
	
	}

	if(slabReminderCount>=1){

	amountArray.push(amount-(slab*slabCount)); 
	}


		for( var i = 0; i < amountArray.length; i++){ 
		
		
				//alert('arr begining'+amountArray);
				amountArray.splice(i, 1); 
				i--; 
				// alert('arr ending'+amountArray);
		
		
		}
       
	}
	componentWillUnmount(){
    }


	

  

    

    render(){

    return(
           
        		<div class="row">
			    <HeaderProfile/>
				<MonthlyTransaction/>
				<SearchSenderDetails/>

				
				</div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone}}
	) => ({
		errorMessage,loginErrorMessage,phone
});

export default connect(mapStateToProps, null)(Header);
